import { isValid, parseISO } from 'date-fns';

export const ZERO_TIMER_COUNT = '00:00:00';

/**
 * Formats a time difference in seconds into a timer value string "HH:MM:SS".
 *
 * @param {number} seconds - The positive time difference in seconds (float value)
 * @returns {string} The timer in "HH:MM:SS" format.
 */
export const formatSecondsToTimer = (seconds: number): string => {
  // biome-ignore lint/style/noMagicNumbers: 1 hour has 3600 seconds
  const hours = Math.floor(seconds / 3600);
  // biome-ignore lint/style/noMagicNumbers: 1 hour has 3600 seconds
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const numberPadding = (value: number) => String(value).padStart(2, '0');

  return `${numberPadding(hours)}:${numberPadding(minutes)}:${numberPadding(remainingSeconds)}`;
};

/**
 *
 * @param {string} [dateTime] - The date and time in UTC, ISO 8601 format (e.g., '2024-08-20T09:56:59.287Z')
 *
 * @returns {number} time difference in seconds
 */
export const getTimeDifferenceInSeconds = (dateTime: string): number => {
  const parsedDate = parseISO(dateTime);

  if (!isValid(parsedDate)) {
    return Number.NaN;
  }

  const nowMs = Date.now();
  const expiryMs = parsedDate.getTime();

  // biome-ignore lint/style/noMagicNumbers: 1000 ms in 1 second
  return Math.floor((expiryMs - nowMs) / 1000);
};

export const getTimerValue = (bidExpiryDateTime: string) => {
  const timeDifference = getTimeDifferenceInSeconds(bidExpiryDateTime);
  return timeDifference > 0 ? formatSecondsToTimer(timeDifference) : ZERO_TIMER_COUNT;
};
